"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferPublicDeployEnvFromHost = inferPublicDeployEnvFromHost;
exports.normalizeDeploymentSiteCodeForPublicWeb = normalizeDeploymentSiteCodeForPublicWeb;
exports.deploymentSitePublicWebHost = deploymentSitePublicWebHost;
exports.deploymentSitePublicWebOrigin = deploymentSitePublicWebOrigin;
exports.deploymentSiteWatermarkSourceLabel = deploymentSiteWatermarkSourceLabel;
exports.deploymentSiteCertificateHeaderTitle = deploymentSiteCertificateHeaderTitle;
exports.deploymentSiteCertificateHeaderSubtitle = deploymentSiteCertificateHeaderSubtitle;
exports.deploymentSiteDocumentationAncrageUrl = deploymentSiteDocumentationAncrageUrl;
const deploymentSiteCodes_1 = require("./deploymentSiteCodes");
const deploymentPublicWebHostResolve_1 = require("./deploymentPublicWebHostResolve");
function normalizeHostForEnvInference(hostInput) {
    var _a, _b;
    const raw = (hostInput !== null && hostInput !== void 0 ? hostInput : "").trim().toLowerCase();
    return (_b = (_a = raw.replace(/^https?:\/\//, "").split("/")[0]) === null || _a === void 0 ? void 0 : _a.split(":")[0]) !== null && _b !== void 0 ? _b : "";
}
function inferEnvFromFirstLabel(host) {
    var _a;
    const first = (_a = host.split(".")[0]) !== null && _a !== void 0 ? _a : "";
    if (first === "test") {
        return "test";
    }
    if (first === "pprod") {
        return "pprod";
    }
    if (first === "prod") {
        return "prod";
    }
    return null;
}
function inferPublicDeployEnvFromHost(hostInput) {
    const host = normalizeHostForEnvInference(hostInput);
    if (host.length === 0 || host === "localhost" || host.startsWith("127.")) {
        return "test";
    }
    const fromPrefix = inferEnvFromFirstLabel(host);
    if (fromPrefix !== null) {
        return fromPrefix;
    }
    if (host === "www.lecoffre.io" || host.endsWith(".lecoffre.io")) {
        return "prod";
    }
    return "test";
}
function normalizeDeploymentSiteCodeForPublicWeb(rawSiteCode) {
    return (0, deploymentSiteCodes_1.sanitizeDeploymentSiteSlug)(rawSiteCode);
}
function deploymentSitePublicWebHost(siteCode, env) {
    return (0, deploymentPublicWebHostResolve_1.resolvePublicWebHostname)(siteCode, env);
}
function deploymentSitePublicWebOrigin(siteCode, env) {
    return `https://${deploymentSitePublicWebHost(siteCode, env)}`;
}
function deploymentSiteWatermarkSourceLabel(siteCode, env) {
    return (0, deploymentPublicWebHostResolve_1.resolveWatermarkSourceLabel)(siteCode, env);
}
function deploymentSiteCertificateHeaderTitle(siteCode) {
    return (0, deploymentPublicWebHostResolve_1.resolveCertificateHeaderTitles)(siteCode).title;
}
function deploymentSiteCertificateHeaderSubtitle(siteCode) {
    return (0, deploymentPublicWebHostResolve_1.resolveCertificateHeaderTitles)(siteCode).subtitle;
}
function deploymentSiteDocumentationAncrageUrl(siteCode, env) {
    return (0, deploymentPublicWebHostResolve_1.resolveDocumentationAncrageUrl)(siteCode, env);
}
